import { FC, useState } from 'react'

import { ProductImage } from './ProductImage'
import { TitleAndPrice } from './TitleAndPrice'
import { UnitSellCodePrice } from './UnitSellCodePrice'
import { KitchenInfo } from './KitchenInfo'
import { Allergens } from './Allergens'
import { Description } from './Description'

import { IProduct } from 'featureSliced/shared/store/reducers/CategoriesReducer/types'
import { KitchenInfoItemType } from '../types'

import {
  ProductMainContainer,
  ProductMainContainerInner,
  LeadDaysWarning,
} from './styled'
import { ProductTemplateIdType } from 'featureSliced/shared/store/reducers/QRMenuBucketReducer/types'
import { RenderIf } from 'components/RenderIf'
import { useTranslations } from 'featureSliced/shared/hooks/useTranslations'
import { handleLocalStorage } from 'featureSliced/shared/utils/handleLocalStorage'
import {
  formatLeadDaysModalWarning,
  getItemLeadDays,
  isItemLeadDaysExceeded,
} from 'featureSliced/shared/utils/itemLeadDays'

type CPCProps = {
  product: IProduct
  productTemplateId: ProductTemplateIdType
  currentAmount?: number
  kitchenInfoState: [
    KitchenInfoItemType,
    (value: (value: KitchenInfoItemType) => any) => void
  ]
}

export const CommonProductComponent: FC<CPCProps> = ({
  product,
  productTemplateId,
  currentAmount = 1,
  kitchenInfoState,
}) => {
  const t = useTranslations()
  const leadDays = getItemLeadDays(product.ClickCollectLeadDaysCount)
  const isLeadDaysExceeded = isItemLeadDaysExceeded({
    leadDays,
    pickUpTime: handleLocalStorage('pickUpTime'),
  })

  return (
    <>
      <ProductMainContainer>
        <ProductImage product={product} productTemplateId={productTemplateId} />
        <ProductMainContainerInner>
          <TitleAndPrice
            product={product}
            productTemplateId={productTemplateId}
            currentAmount={currentAmount}
          />
          <UnitSellCodePrice product={product} currentAmount={currentAmount} />
          <RenderIf condition={isLeadDaysExceeded}>
            <LeadDaysWarning>
              {formatLeadDaysModalWarning(t, leadDays)}
            </LeadDaysWarning>
          </RenderIf>
          <KitchenInfo
            kitchenInfo={product.kitchenInfo}
            kitchenInfoState={kitchenInfoState}
          />
          <Allergens product={product} />
          <Description note={product.note ?? undefined} />
        </ProductMainContainerInner>
      </ProductMainContainer>
    </>
  )
}
